import MDEditor from '@uiw/react-md-editor';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { MultiLanguageInput } from './MultiLanguageLabel';

const MultiLangMarkdown = ({
  source,
  value,
  onChange,
  langCode,
  label,
  editorProps,
  error,
  helperText,
  isRequired,
  disabled,
}) => (
  <MultiLanguageInput
    source={source}
    value={value}
    onChange={onChange}
    label={label}
    error={error}
    helperText={helperText}
    langCode={langCode}
    isRequired={isRequired}
    disabled={disabled}
  >
    <MDEditor
      source={source}
      preview={disabled ? 'preview' : 'edit'}
      extraCommands={[]}
      highlightEnable={false}
      {...editorProps}
    />
  </MultiLanguageInput>
);

MultiLangMarkdown.propTypes = {
  source: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      langCode: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func,
  langCode: PropTypes.string,
  label: PropTypes.node,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default memo(MultiLangMarkdown);
